import { BottomDialog } from 'lib/BottomDialog';
import React from 'react';
import { Box, Button, styled, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { UserData } from './model/User';
import { AxiosResponse } from 'axios';
import { ApplicationState } from 'store/store';
import { useAppleSSO } from './hooks/useAppleSSO';
import { SSO_BUTTON_MAX_WIDTH } from 'config/constants';
import { useTranslation } from 'react-i18next';
import { Throbber } from 'lib/Throbber';

// Potentially fragile
const StyledBox = styled(Box)({
    position: 'relative',
    '& div': {
        '& div': {
            position: 'absolute',
            top: 0,
            left: 0,
            '& svg': {
                position: 'absolute',
                top: 0,
                left: 0
            }
        },
        '& div:first-of-type': {
            '& svg': {
                zIndex: 10
            }
        }
    }
});

interface AppleSSOProps {
    onSignInSuccess: (data: UserData) => void;
    onSignInError: (error: AxiosResponse<{ message: string; code: string }>) => void;
}

export const AppleSSO: React.FC<React.PropsWithChildren<AppleSSOProps>> = ({
    onSignInSuccess,
    onSignInError
}) => {
    const { t } = useTranslation();
    const container = React.useRef<HTMLDivElement>(null);
    const { settings } = useSelector((state: ApplicationState) => state.settings);

    const { brokenUserPopup, loading } = useAppleSSO(onSignInSuccess, onSignInError);
    const handleRefresh = React.useCallback(() => {
        window.location.reload();
    }, []);
    const buttonWidth =
        (container.current?.clientWidth ?? 0) > SSO_BUTTON_MAX_WIDTH
            ? SSO_BUTTON_MAX_WIDTH
            : container.current?.clientWidth ?? 0;
    return (
        <React.Fragment>
            {settings?.appleSSOEnabled && (
                // Flex item mirroring GoogleSSO: grows up to the SSO max width, floored at 200px,
                // wrapping to its own row when there isn't space to sit beside Google.
                <Box
                    ref={container}
                    sx={{ flex: '1 1 240px', minWidth: 200, maxWidth: SSO_BUTTON_MAX_WIDTH }}
                >
                    <Box display="flex" justifyContent="center" fontSize="12px">
                        <StyledBox id="appleid-signin" data-height="40" data-width={buttonWidth} />
                    </Box>
                </Box>
            )}
            <BottomDialog open={brokenUserPopup}>
                <Box>
                    <Typography variant="h6" align="center">
                        {t('ACCOUNT_EXISTING_SSO_ERROR_TITLE')}
                    </Typography>
                    <Typography align="center">{t('ACCOUNT_EXISTING_SSO_ERROR_MESSAGE')}</Typography>
                    <Button variant="contained" color="primary" onClick={handleRefresh}>
                        {t('GENERAL_NOTIFICATION_DISMISS')}
                    </Button>
                </Box>
            </BottomDialog>
            {loading && <Throbber isFullScreen text="" />}
        </React.Fragment>
    );
};
